module.exports = __webpack_public_path__ + "static/mobile-f50e427dae3736b2df553841f65e966f.png";